module.exports = __webpack_public_path__ + "img/kiesreis_logo_background.7b72d2a5.png";